import type {RequestFilter} from './types';

export const merchantConfigFilter: RequestFilter = {
  matchers: [
    {
      urlPath: /\/graphql\/multiregion/,
      method: 'POST',
      body: /RetrieveMerchantConfigForWorkspaceLazyQuery/,
    },
    {
      urlPath: /\/graphql\/multiregion/,
      method: 'POST',
      body: /UpdateMerchantConfigForWorkspaceMutation/,
    },
  ],

  filterRequest: (requestData) => ({
    ...requestData,
    keyType: 'account_session',
  }),
};
